













































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { passwordRulesEl, mobileRulesEl } from "@/utils/verify";
const user = namespace("user");
@Component({})
export default class ForgetPwd extends Vue {}
